import React from 'react';
import { useState } from 'react';
import { ReactComponent as MapaCompleto } from './completo.svg'; // Este SVG contiene todas las provincias
import './MapaVeracruz.css'
function MapaVeracruz() {

    // Maneja el mouseMove (o mouseOver) en el contenedor
    const handleMouseMove = (event) => {
        const hoveredElement = event.target;

        // Verifica si es un path con clase 'cls-1', 'cls-2', etc.
        //   switch(hoveredElement){ No entiendo porque el Switch no funciona si literal es la misma funcion que el else if
        //     case(hoveredElement.matches(".fil0")):
        //         console.log("Hover sobre 'fil0'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil1")):
        //         console.log("Hover sobre 'fil2'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil2")):
        //         console.log("Hover sobre 'fil2'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil3")):
        //         console.log("Hover sobre 'fil3'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil4")):
        //         console.log("Hover sobre 'fil4'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil5")):
        //         console.log("Hover sobre 'fil5'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil6")):
        //         console.log("Hover sobre 'fil6'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil7")):
        //         console.log("Hover sobre 'fil7'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil8")):
        //         console.log("Hover sobre 'fil8'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil9")):
        //         console.log("Hover sobre 'fil9'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     case(hoveredElement.matches(".fil10")):
        //         console.log("Hover sobre 'fil10'");
        //         // regionSelecionada = "1.56 mil M \n OLMECA"
        //     ;
        //     default:
        //         // regionSelecionada = "";
        //   }


        if (hoveredElement.matches(".fil0")) {
            console.log("Se está haciendo hover sobre la provincia 'fil0'");
            showTooltip("2.09 mil M - OLMECA");
        } else if (hoveredElement.matches(".fil1")) {
            console.log("Hover en 'fil1'");
            showTooltip("1.56 mil M - HUASTECA ALTA");
        } else if (hoveredElement.matches(".fil2")) {
            console.log("Hover en 'fil2'");
            showTooltip("1.52 mil M - PAPALOAPAN");
        } else if (hoveredElement.matches(".fil3")) {
            console.log("Hover en 'fil3'");
            showTooltip("1.56 mil M - HUASTECA BAJA");
        } else if (hoveredElement.matches(".fil4")) {
            console.log("Hover en 'fil4'");
            showTooltip("4.12 mil M - LAS MONTAÑAS");
        } else if (hoveredElement.matches(".fil5")) {
            console.log("Hover en 'fil5'");
            showTooltip("8.54 mil M - CAPITAL");
        } else if (hoveredElement.matches(".fil6")) {
            console.log("Hover en 'fil6'");
            showTooltip("1.69 mil M - TOTONACA");
        } else if (hoveredElement.matches(".fil7")) {
            console.log("Hover en 'fil7'");
            showTooltip("2.67 mil M - SOTAVENTO");
        } else if (hoveredElement.matches(".fil8")) {
            console.log("Hover en 'fil8'");
            showTooltip("1.07 mil M - NAUTLA");
        } else if (hoveredElement.matches(".fil9")) {
            console.log("Hover en 'fil9'");
            showTooltip("756.77 millones - TUXTLAS");
        } else if (hoveredElement.matches(".fil10")) {
            console.log("Hover en 'fil10'");
            showTooltip("2.09 mil M - OLMECA");
        } else {
            // Hover en un área sin clase reconocida
            hideTooltip()
        }
    };

    const [tooltip, setTooltip] = useState({
        visible: false,
        text: ""
    });

    // Función para mostrar el tooltip (por ejemplo, al hacer hover)
    const showTooltip = (text) => {
        setTooltip({
            visible: true,
            text
        });
    };

    // Función para ocultar el tooltip
    const hideTooltip = () => {
        setTooltip({
            visible: false,
            text: ""
        });
    };

    return (
        <div className='svg-container' onMouseMove={handleMouseMove}>
            <MapaCompleto style={{ width: '700px', height: 'auto' }} />

            {/* Renderizamos el tooltip SÓLO si tooltip.visible es true */}
            {tooltip.visible && (
                <div className='tooltip'>
                    {tooltip.text}
                </div>
            )}

    {/* <div class="tooltip2">1.56 mil M HUASTECA ALTA</div> */}
      {/*<div class="tooltip3">Papaloapan</div>
      <div class="tooltip4">Huasteca alta</div>
      <div class="tooltip5">Las montañas</div>
      <div class="tooltip6">Capital</div>
      <div class="tooltip7">Totonaca</div>
      <div class="tooltip8">Sotavento</div>
      <div class="tooltip9">Nautla</div>
      <div class="tooltip10">Tuxtlas</div> */}
        </div >

    );
}

export default MapaVeracruz;
